// Canonicalizes US state values to 2-letter codes. The clients table stores
// `state` as free text and two write paths disagree (broker form saves "CA",
// CSV import wrote raw "California"), producing duplicate filter entries and
// breaking code that expects a 2-letter code. Use this on any state input.

import { US_STATES } from "../schemas/forms";

// lowercased full name -> code (e.g. "california" -> "CA")
const NAME_TO_CODE: Record<string, string> = {};
// valid 2-letter codes (uppercase), e.g. "CA"
const VALID_CODES = new Set<string>();
for (const { value, label } of US_STATES) {
  NAME_TO_CODE[label.toLowerCase()] = value;
  VALID_CODES.add(value);
}
// DC ships under a few labels across the codebase / source data.
NAME_TO_CODE["district of columbia"] = "DC";
NAME_TO_CODE["washington dc"] = "DC";
NAME_TO_CODE["washington d.c."] = "DC";

export function normalizeStateToCode(
  value: string | null | undefined,
): string | null {
  if (value == null) return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;

  // Already a valid 2-letter code.
  if (trimmed.length === 2 && VALID_CODES.has(trimmed.toUpperCase())) {
    return trimmed.toUpperCase();
  }

  // Full name (case-insensitive).
  const code = NAME_TO_CODE[trimmed.toLowerCase()];
  if (code) return code;

  // Unknown — preserve the original (trimmed) rather than dropping data.
  return trimmed;
}
